export default __webpack_public_path__ + "static/assets/3cc01e2f65b202a8adefc8a71569b830.svg";